import React, { useState } from 'react';
import axios from 'axios';
import { Lock, Unlock, ArrowRight, Eye, EyeOff } from 'lucide-react';

const apiUrl = process.env.REACT_APP_API_URL;

const LockScreen = ({ onUnlock }) => {
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isChecking, setIsChecking] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        if (!password) return;

        setIsChecking(true);
        try {
            const res = await axios.post(`${apiUrl}/api/admin/security/verify-password`, {
                Password: password
            });

            if (res.data?.Succeeded) {
                // Unlock successful
                sessionStorage.setItem('superAdminUnlocked', 'true');
                onUnlock();
            } else {
                setError(res.data?.Message || "Invalid password");
            }
        } catch (err) {
            console.error("Error verifying password", err);
            setError("Failed to verify password");
        } finally {
            setIsChecking(false);
        }
    };

    return (
        <div className="d-flex flex-column align-items-center justify-content-center py-5 w-100" style={{ minHeight: '60vh' }}>
            <div
                className="card border-0 p-4 position-relative overflow-hidden"
                style={{
                    maxWidth: '400px',
                    width: '100%',
                    marginTop: '20px',
                    background: 'rgba(255, 255, 255, 0.85)',
                    backdropFilter: 'blur(16px)',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
                    borderRadius: '24px',
                    border: '1px solid rgba(255,255,255,0.5)'
                }}
            >
                {/* Decorative background element */}
                <div className="position-absolute rounded-circle" style={{ width: '150px', height: '150px', background: 'linear-gradient(135deg, rgba(13,110,253,0.1) 0%, rgba(13,202,240,0.1) 100%)', top: '-50px', right: '-50px', zIndex: 0 }}></div>

                <div className="text-center mb-4 position-relative" style={{ zIndex: 1 }}>
                    <div
                        className="text-white rounded-circle d-inline-flex p-4 mb-4 shadow-sm"
                        style={{ background: 'linear-gradient(135deg, #0d6efd 0%, #0dcaf0 100%)' }}
                    >
                        <Lock size={40} strokeWidth={2.5} />
                    </div>
                    <h3 className="fw-bolder text-dark mb-2" style={{ letterSpacing: '-0.5px' }}>Restricted Area</h3>
                    <p className="text-body-secondary fs-9 mb-0 px-3">
                        This zone is protected by Super Admin credentials. Please authenticate to proceed.
                    </p>
                </div>

                {error && (
                    <div className="alert alert-danger py-2 px-3 mb-4 d-flex align-items-center fs-9 fw-bold">
                        <Lock size={16} className="me-2 flex-shrink-0" />
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="position-relative" style={{ zIndex: 1 }}>
                    <div className="mb-3 position-relative">
                        <input
                            type={showPassword ? "text" : "password"}
                            className="form-control pe-5"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoFocus
                        />
                        <button
                            type="button"
                            className="btn btn-link position-absolute end-0 top-50 translate-middle-y text-body-tertiary p-0 px-3 text-decoration-none"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                        </button>
                    </div>
                    <button
                        type="submit"
                        className="btn w-100 fw-bold d-flex align-items-center justify-content-center text-white border-0"
                        disabled={isChecking || !password}
                        style={{
                            borderRadius: '10px',
                            background: '#2f5aa2',
                            padding: '0.6rem',
                            boxShadow: '0 4px 12px rgba(47, 90, 162, 0.3)',
                            fontSize: '1rem'
                        }}
                    >
                        {isChecking ? (
                            <span className="spinner-border spinner-border-sm me-2" />
                        ) : (
                            <Unlock size={18} className="me-2" strokeWidth={2.5} />
                        )}
                        Unlock Secure Area
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LockScreen;
